<template>
  <div class="menu">

    <certificar-login 
      ref="certificarLogin"
      @confirmarCertificarLogin="confirmarCertificarLogin"
    />

    <div class="w3-bar w3-top w3-theme w3-large" style="z-index:4">
      <button 
        class="w3-bar-item w3-button botao-quadrado w3-hover-none  btn-abre-menu"
        @click="w3_open();">
        <span class="w3-white"/>
        <span class="w3-white"/>
        <span class="w3-white"/>
      </button>
      
      <div class="w3-bar-item w3-right w3-dropdown-hover">
        <div class="w3-col s12">
          <div 
            class="circulo-letra-detalhes w3-border w3-center w3-circle">
            {{getPrimeiraLetraNome(usuario_logado.nome)}}
          </div>
        </div>

        <div 
          id="aba-usuario" 
          class="w3-dropdown-content w3-border w2-bar-block" 
          style="width: 300px; position: fixed; right: 0; top: 43px;padding: 20px 20px 10px; text-align: center;">

          <div class="w3-col s12">
            <div 
              class="circulo-letra w3-border w3-center w3-circle">
              {{getPrimeiraLetraNome(usuario_logado.nome)}}
            </div>
          </div>
          
          <span v-cloak class="texto-preto">
            <label v-if="usuario_logado.tipo_autenticacao == 'MOT'">Motorista:</label>
            <label v-if="usuario_logado.tipo_autenticacao == 'FRN'">Fornecedor:</label>
            <strong class="texto-vermelho w3-medium">{{usuario_logado.cadastro_id + ' - ' + usuario_logado.nome}}</strong>
          </span>

          <div v-cloak class="texto-preto" style="font-size: 16px; margin-top: 10px;" v-if="usuario_logado.tipo_autenticacao == 'MOT'">
            <label class="w3-col">Logado em: </label>
            <strong class="texto-preto w3-medium w3-col"> {{empresa_logada.empresa_id + ' - ' + empresa_logada.nome_fantasia}} </strong>
          </div>

          <div  
            style="width: 100%; text-align: left; font-size: 15px;"
            class="w3-bar-item w3-button botao-quadrado w3-padding"
            v-if="(usuario_logado.tipo_autenticacao == 'MOT') && (Object.keys(empresas_autorizadas).length > 1)">
            <i class="fas fa-building fa-fw w3-text-theme"/>

            <label 
              class="w3-text-theme"
              style="text-decoration: underline;" 
              @click="mostrar_empresas = !mostrar_empresas">
              <span>Selecionar empresa</span>
            </label>

            <div :style="getClassListaEmpresas()">
              <div
                style="margin-top: 5px;"
                :key="empresa.empresa_id"
                v-show="mostrar_empresas"
                @click="trocarEmpresa(empresa)"
                v-for="empresa in empresas_autorizadas"
                class="w3-btn w3-white w3-border w3-border-theme w3-small w3-padding-small w3-col">
                <label>{{empresa.empresa_id}} - {{empresa.nome_resumido}}</label>
              </div>
            </div>
          </div>
          
          <div class="w3-col">
            <div class="w3-col s12 w3-bar">

              <div v-if="usuario_logado.tipo_autenticacao == 'MOT'">
                <router-link  
                  to="/manifestos"
                  style="width: 100%; text-align: left;" 
                  @click.native="checarPagina('/manifestos')"
                  class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto w3-medium">
                  <i class="fa fa-truck fa-fw w3-text-theme"/> Manifestos
                </router-link>
              </div>

              <div v-if="usuario_logado.tipo_autenticacao == 'FRN'">
                <router-link  
                  to="/cotacoes-fornecedores"
                  style="width: 100%; text-align: left;" 
                  @click.native="checarPagina('/cotacoes-fornecedores')"
                  class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto w3-medium">
                  <i class="fa fa-cart-arrow-down fa-fw w3-text-theme"/> Cotações
                  <span class="texto-vermelho" v-cloak> {{ '(' + usuario_logado.quantidade_cotacoes + ')' }} </span>
                </router-link>
              </div>
              
              <br>
              <button
                @click="logout"
                style="width: 100%; text-align: left; font-size: 16px;" 
                class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
                <i class="fa fa-sign-out-alt fa-fw w3-text-theme"/> Sair
              </button>

            </div>
          </div>
        </div>
      </div>
    </div>

    <nav 
      class="w3-sidebar w3-white w3-animate-left" 
      style="z-index:3;width:300px;display: none;" 
      id="menu">
      <br>
      <div class="w3-bar-block w3-margin-bottom" v-cloak>
        <div class="w3-padding margin-0">
          <h5>
            <span>Opções</span>
          </h5>
        </div>

        <div v-if="usuario_logado.tipo_autenticacao == 'MOT'">
          <router-link
            to="/manifestos"
            @click.native="checarPagina('/manifestos')"
            style="width: 100%; text-align: left;"
            class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
            <i class="fa fa-truck w3-text-theme"/> Manifestos
          </router-link>
        </div>
        
        <div v-if="usuario_logado.tipo_autenticacao == 'FRN'">
          <router-link
            to="/cotacoes-fornecedores"
            @click.native="checarPagina('/cotacoes-fornecedores')"
            style="width: 100%; text-align: left;"
            class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
            <i class="fa fa-cart-arrow-down w3-text-theme"/> Cotações
          </router-link>
        </div>

        <button
          @click="logout"
          style="width: 100%; text-align: left;" 
          class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
          <i class="fa fa-sign-out-alt fa-fw w3-text-theme"/> Sair
        </button>
        <br>
        <br>
      </div>
    </nav>

    <div 
      class="w3-overlay w3-animate-opacity"
      @click="w3_close()" 
      style="cursor:pointer"
      id="myOverlay">
    </div>
  </div>
</template>

<script>
import RLogout from '@/components/Rest/RLogout.js';
import RSessao from "@/components/Rest/RSessao.js";
import CertificarLogin from '@/components/CertificarLogin'
import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  name: "MenuTerceiros",

  components: {
    CertificarLogin
  },

  data() {
    return {
      api: process.env.API,
      empresa_logada: {},
      usuario_logado: {},
      mostrar_empresas: false,
      certificarLoginAberto: false,
      empresas_autorizadas: [],
    };
  },
  
  methods: {
    checarPagina(urlAtual) {
      if (this.$route.path === urlAtual){
        this.$router.go(this.$route.path)
      }
    },
    
    async logout(){  
      try {
        await RLogout.realizarLogout(this.axios);
        window.location.href = "/login-terceiros";
      } catch (error) {
        console.log('Erro ao realizar logout: ' + JSON.stringify(error));
      }
    },

    getPrimeiraLetraNome(nome){
      if (nome){
        return nome.substr(0, 1);
      } else {
        return '?';
      }
    },

    getClassListaEmpresas() {
      if (!this.mostrar_empresas) {
        return '';
      }

      if (this.empresas_autorizadas.length < 5) {
        return 'overflow: auto; height: 200px;';
      }
      else if (this.empresas_autorizadas.length > 5) {
        return 'overflow-y: scroll; height: 200px;';
      }
    },

    async trocarEmpresa(empresa) {
      try {
        let parametros = {
          empresa_id : empresa.empresa_id
        }

        let retorno = await RSessao.trocarEmpresa(this.axios, parametros);

        if (retorno.houve_erro == 'S') {
          throw new Error(retorno.mensagem);
        }

        Biblioteca.informar('Empresa ' + empresa.nome_resumido + ' selecionada com sucesso.');
        await this.buscarDadosSessaoTerceiros();
        
        window.location.href = '/principal-terceiros';
      }
      catch (e) {
        Biblioteca.exclamar('Não foi possível trocar de empresa! ' + e.message);
      }
    },
    
    async buscarDadosSessaoTerceiros() {
      try {
        let retorno = await RSessao.buscarDadosSessaoTerceiros(this.axios);
        
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        // Dados de usuário
        this.usuario_logado = JSON.parse(JSON.stringify(retorno.dados.usuario_logado)); 

        // Dados de empresa
        if (retorno.dados.empresa_logada){
          this.empresa_logada = JSON.parse(JSON.stringify(retorno.dados.empresa_logada)); 
        }

        if (retorno.dados.empresas){
          this.empresas_autorizadas = JSON.parse(JSON.stringify(retorno.dados.empresas)); 
        }
      } catch (error) {
        Biblioteca.exclamar("Sessão não foi iniciada corretamente, motivo: " + error.message);
      }
    },
    
    w3_open: function() {
      var mySidebar = document.getElementById("menu");
      var overlayBg = document.getElementById("myOverlay");
      var btnMenu = document.querySelector(".btn-abre-menu");

      if (mySidebar.style.display === "block") {
        mySidebar.style.display = "none";
        overlayBg.style.display = "none";
        btnMenu.classList.remove("open");
      } else {
        mySidebar.style.display = "block";
        overlayBg.style.display = "block";
        btnMenu.classList.add("open");
      }
    },
    
    w3_close: function() {
      var mySidebar = document.getElementById("menu");
      var overlayBg = document.getElementById("myOverlay");
      var btnMenu = document.querySelector(".btn-abre-menu");
      mySidebar.style.display = "none";
      overlayBg.style.display = "none";
      btnMenu.classList.remove("open");
    },

    async verificarSessaoExpirada(){
      try {
        let dados_sessao_usuario = await RSessao.getDadosSessaoUsuario();
        dados_sessao_usuario = await JSON.parse(JSON.stringify(dados_sessao_usuario));

        if 
          (
            (!this.certificarLoginAberto) &&
            (dados_sessao_usuario.usuario_id) &&
            (dados_sessao_usuario.exigir_certificacao_login == 'S')
          )
        {
          this.certificarLoginAberto = true;
          swal("É necessário realizar o login para concluir esta operação!");
          this.$refs.certificarLogin.abrir();
        }
      } catch (error) {
        // Fazer nada.
      }
    },

    confirmarCertificarLogin(){
      this.certificarLoginAberto = false;
    },
  },
  
  async created() {
    await this.buscarDadosSessaoTerceiros();
  },

  async mounted() {
    await this.verificarSessaoExpirada();

    setInterval(async () => {
        await this.verificarSessaoExpirada();
      }, 
      3000
    );
  },
}
</script>

<style scoped>
  .menu {
    margin-top: 40px;
  }

  .btn-abre-menu {
    width: 29px;
    height: 25px;
    position: absolute;
    top: 15px;
    left: 10px;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: 0.5s ease-in-out;
    -moz-transition: 0.5s ease-in-out;
    -o-transition: 0.5s ease-in-out;
    transition: 0.5s ease-in-out;
    cursor: pointer;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    outline: none !important;
  }
  
  .btn-abre-menu span {
    display: block;
    position: absolute;
    height: 2px;
    width: 21px;
    background: #9c1d1c;
    border-radius: 9px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: 0.25s ease-in-out;
    -moz-transition: 0.25s ease-in-out;
    -o-transition: 0.25s ease-in-out;
    transition: 0.25s ease-in-out;
  }
  
  .btn-abre-menu span:nth-child(1) {
    top: 0px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
  }
  
  .btn-abre-menu span:nth-child(2) {
    top: 6px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
    }
  
  .btn-abre-menu span:nth-child(3) {
    top: 12px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
  }
  
  .btn-abre-menu.open span:nth-child(1) {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
    top: -1px;
    left: 2px;
  }
  
  .btn-abre-menu.open span:nth-child(2) {
    width: 0%;
    opacity: 0;
    }
    
  .btn-abre-menu.open span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 14px;
    left: 2px;
  }
  
  .preview-mensagens {
    text-decoration: none;
  }
  
  .container-preview {
    background-color: #e6e6e6;
  }
  
  .div-preview {
    border-bottom: 1px solid white;
  }
  
  .texto-lido {
    color: rgb(39, 39, 39);
  }

  .menu h5{
    border-bottom: 1px solid #000;
  }
  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd; 
  }
  
  ::-webkit-scrollbar-thumb {
    background: #8d1007; 
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c; 
  }
  
  @media screen and (min-width: 1180px){
    #menu a:hover{background-color: #ddd !important;}
  }

  .circulo-letra {
    width: 70px; 
    height: 70px; 
    background-color: #9c1d1c; 
    color: #f7f7f7; 
    background-size: cover; 
    font-weight: bold; 
    font-size: 40px; 
    display: inline-block; 
    padding-top: 1px;
    border: 3px solid #ebe6e6!important; 
    box-shadow: #6b6b6b 2px 2px 5px 2px;
    margin-bottom: 10px;
  }

  .circulo-letra-detalhes {
    width: 30px; 
    height: 30px; 
    background-color: #9c1d1c; 
    color: #f7f7f7; 
    background-size: cover; 
    font-weight: bold; 
    font-size: 15px; 
    display: inline-block; 
    padding-top: 1px;
    border: 3px solid #ebe6e6!important; 
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MenuTerceiros.vue